
// viva_ui/src/Reports/ReportsTable.js
 
import React, { useState, useEffect, useRef } from 'react';
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material';
import Sidebar from '../Temp/Sidebar/Sidebar';
import ReportFilters from './ReportFilters';
import ReportDataTable from './ReportDataTable';
import EmployeeWiseReportTable, {
  employeeWiseQueryBuilderColumns,
} from './EmployeeWiseReportTable';
import { useOutletContext, Navigate, useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';

const stringOperators = [
  { value: 'contains', key: 'Contains' },
  { value: 'equal', key: 'Equal' },
  { value: 'notequal', key: 'Not Equal' },
  { value: 'startswith', key: 'Starts With' },
  { value: 'endswith', key: 'Ends With' },
  { value: 'isempty', key: 'Is Empty' },
  { value: 'isnotempty', key: 'Is Not Empty' },
];

const numberOperators = [
  { value: 'equal', key: 'Equal' },
  { value: 'notequal', key: 'Not Equal' },
  { value: 'greaterthan', key: 'Greater Than' },
  { value: 'lessthan', key: 'Less Than' },
  { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
  { value: 'lessthanorequal', key: 'Less Than Or Equal' },
];

const courseReportQueryBuilderColumns = [
  { field: 'title', label: 'Title', type: 'string', operators: stringOperators },
  { field: 'exam_type', label: 'Assessment Type', type: 'string', operators: stringOperators },
  { field: 'pass_percent', label: 'Pass Percentage', type: 'number', operators: numberOperators },
  {
    field: 'isenable',
    label: 'Is Enable',
    type: 'string',
    operators: [{ value: 'equal', key: 'Equal' }],
    values: ['True', 'False'],
  },
];
 
export const ReportsTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialTab =
    new URLSearchParams(location.search).get("tab") === "employee"
      ? "employee"
      : "exam";

  const [activeTab, setActiveTab] = useState(initialTab);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRule, setFilterRule] = useState(null);
  const [employeeSearchTerm, setEmployeeSearchTerm] = useState('');
  const [employeeFilterRule, setEmployeeFilterRule] = useState(null);
  const [employeeReports, setEmployeeReports] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(true);
  const [employeeTotalCount, setEmployeeTotalCount] = useState(0);
  const [employeePage, setEmployeePage] = useState(
    Number(new URLSearchParams(location.search).get("employeePage")) || 1
  );
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  // const [page, setPage] = useState(1);
  // const pageSize = 5;
  const initialPage =
    Number(new URLSearchParams(location.search).get("page")) || 1;
 
  const [page, setPage] = useState(initialPage);
 
  const pageSize = 10;
  const courseRequestIdRef = useRef(0);
  const employeeRequestIdRef = useRef(0);
  const courseFiltersInitializedRef = useRef(false);
  const employeeFiltersInitializedRef = useRef(false);

  const fetchEmployeeReports = async (pageNum = 1) => {
    const requestId = employeeRequestIdRef.current + 1;
    employeeRequestIdRef.current = requestId;

    try {
      setEmployeeLoading(true);

      const params = new URLSearchParams({
        search: employeeSearchTerm,
        page: pageNum,
        page_size: pageSize,
      });

      if (employeeFilterRule && employeeFilterRule.rules?.length) {
        params.append('filters', JSON.stringify(employeeFilterRule));
      }

      const response = await axios.get(`/reports/employee-wise/?${params.toString()}`, {
        withCredentials: true
      });
      const data = response.data;

      if (response.status < 200 || response.status >= 300) {
        if (requestId !== employeeRequestIdRef.current) return;
        alert(data.error || 'Failed to load employee reports');
        setEmployeeReports([]);
        setEmployeeTotalCount(0);
        return;
      }

      if (requestId !== employeeRequestIdRef.current) return;
      setEmployeeReports(data.reports || []);
      setEmployeeTotalCount(data.total_count || 0);
      setEmployeePage(pageNum);
    } catch (error) {
      if (requestId !== employeeRequestIdRef.current) return;
      console.error('Error fetching employee reports:', error);
      setEmployeeReports([]);
      setEmployeeTotalCount(0);
    } finally {
      if (requestId === employeeRequestIdRef.current) {
        setEmployeeLoading(false);
      }
    }
  };

  const fetchReports = async (pageNum = 1) => {
    const requestId = courseRequestIdRef.current + 1;
    courseRequestIdRef.current = requestId;

    try {
      setLoading(true);
 
      const params = new URLSearchParams({
        search: searchTerm,
        page: pageNum,
        page_size: pageSize,
      });
 
      if (filterRule && filterRule.rules?.length) {
        params.append('filters', JSON.stringify(filterRule));
      }
 
      const response = await axios.get(`/reports/courses/?${params.toString()}`, {
        withCredentials: true
      });
      const data = response.data;
 
      if (requestId !== courseRequestIdRef.current) return;
      setReports(data.reports || []);
      setTotalCount(data.total_count || 0);
      setPage(pageNum);
    } catch (error) {
      if (requestId !== courseRequestIdRef.current) return;
      console.error('Error fetching reports:', error);
      setReports([]);
      setTotalCount(0);
    } finally {
      if (requestId === courseRequestIdRef.current) {
        setLoading(false);
      }
    }
  };
 
 
  const handleEnableChange = async (examId, checked) => {
    console.log("hIII")
 
    try {
 
      await axios.patch(
        `/reports/exam-enable/${examId}/`,
        {
          isenable: checked
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
 
      fetchReports(page);
 
    } catch (error) {
      console.error("Error updating enable status:", error);
    }
  };
 
  // Reset to page 1 when search or filter changes
  useEffect(() => {
    if (!courseFiltersInitializedRef.current) {
      courseFiltersInitializedRef.current = true;
      fetchReports(page);
      return;
    }

    if (activeTab !== 'exam') return;

    setPage(1);
    navigate('/report?page=1', { replace: true });
    fetchReports(1);
  }, [searchTerm, filterRule]);

  useEffect(() => {
    if (!employeeFiltersInitializedRef.current) {
      employeeFiltersInitializedRef.current = true;
      fetchEmployeeReports(employeePage);
      return;
    }

    if (activeTab !== 'employee') return;

    setEmployeePage(1);
    navigate('/report?tab=employee&employeePage=1', { replace: true });
    fetchEmployeeReports(1);
  }, [employeeSearchTerm, employeeFilterRule]);




  const handleExportCSV = async () => {
    try {
      const params = new URLSearchParams({
        search: searchTerm,
      });
 
      if (filterRule && filterRule.rules?.length) {
        params.append('filters', JSON.stringify(filterRule));
      }
 
      const response = await axios.get(`/reports/courses/export/?${params.toString()}`, {
        withCredentials: true
      });
      const data = response.data;
 
      if (!data.reports || data.reports.length === 0) {
        alert('No data to export!');
        return;
      }
 
 
 
      const headers = [
        'Title',
        // 'Difficulty',
        'Exam Type',
        // 'Enrolled',
        'Pass %',
      ];
 
      const rows = data.reports.map((r) => [
        r.title || '',
        // r.difficulty || '',
        r.exam_type || '',
        // r.enrolled || 0,
        // r.pass_percent ? `${r.pass_percent}%` : '—',
        r.pass_percent != null
          ? `${Number(r.pass_percent).toFixed(2)}%`
          : '—',
      ]);
 
      const csvContent =
        'data:text/csv;charset=utf-8,' +
        [headers.join(','), ...rows.map((r) => r.join(','))].join('\n');
 
      const link = document.createElement('a');
      link.href = encodeURI(csvContent);
      link.download = 'course_reports.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting CSV:', error);
      alert('Failed to export data.');
    }
  };
 
  const { permissionSet, permissionsLoading } = useOutletContext();
  if (permissionsLoading) return <div>Loading...</div>;
 
  const canAccessAssessment = permissionSet.has(7) || permissionSet.has(3);
 
  if (!canAccessAssessment) {
    return <Navigate to="/error" replace />;
  }
  const handlePageChange = (newPage) => {
    navigate(`/report?page=${newPage}`, { replace: true });
    fetchReports(newPage);
  };

  const handleEmployeePageChange = (newPage) => {
    navigate(`/report?tab=employee&employeePage=${newPage}`, { replace: true });
    fetchEmployeeReports(newPage);
  };

  return (
    <div className="flex min-h-screen">
      {/* <div className="w-[95px] flex-shrink-0">
        <Sidebar />
      </div> */}
      <div className="flex-1 overflow-auto pl-6 pr-6 pt-6">
        <div className="bgImage">
          <Box className="MainSectionTop" sx={{ pl: 3, pr: 3 }}>
            <Card
              sx={{
                background: '#fff',
                borderRadius: 2,
                boxShadow: 2,
                mt: 3,
              }}
            >
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Reports
                </Typography>

                <Tabs
                  value={activeTab}
                  onChange={(event, value) => setActiveTab(value)}
                  sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
                >
                  <Tab label="Course Reports" value="exam" />
                  <Tab label="Employee Reports" value="employee" />
                </Tabs>

                <Box hidden={activeTab !== 'exam'}>
                  <ReportFilters
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    setFilterRule={setFilterRule}     // pass down
                    queryBuilderColumns={courseReportQueryBuilderColumns}
                    handleExportCSV={handleExportCSV}
                  />

                  <ReportDataTable
                    filteredReports={reports}
                    loading={loading}
                    page={page}
                    setPage={handlePageChange}
                    pageSize={pageSize}
                    totalCount={totalCount}
                    handleEnableChange={handleEnableChange}
                  />
                </Box>

                <Box hidden={activeTab !== 'employee'}>
                  <ReportFilters
                    searchTerm={employeeSearchTerm}
                    setSearchTerm={setEmployeeSearchTerm}
                    setFilterRule={setEmployeeFilterRule}
                    searchPlaceholder="Search by Employee, Employee ID, Department, Pass %"
                    queryBuilderColumns={employeeWiseQueryBuilderColumns}
                    showReportButton={false}
                  />

                  <EmployeeWiseReportTable
                    reports={employeeReports}
                    loading={employeeLoading}
                    page={employeePage}
                    setPage={handleEmployeePageChange}
                    pageSize={pageSize}
                    totalCount={employeeTotalCount}
                  />
                </Box>
              </CardContent>
            </Card>
          </Box>
        </div>
      </div>
    </div>
  );
};
 
export default ReportsTable;
